// Local Storage utility for search conditions
const SEARCH_STORAGE_KEY = 'freelance_search_conditions';

export interface SearchFilters {
  keyword?: string;
  skill_ids?: number[];
  occupation_ids?: number[];
  industry_ids?: number[];
  characteristic_ids?: number[];
  prefecture_ids?: number[];
  workstyle_types?: string[];
  availability_types?: string[];
  price_over?: number;
  payment_site?: string;
  settlement_hours?: string;
  interview_count_max?: number;
  published_within?: number;
  is_recruiting?: boolean;
  remote_types?: string[];
  workday_types?: string[];
  sort?: string;
  page?: number;
}

export const saveSearchConditions = (conditions: SearchFilters): void => {
  if (typeof window !== 'undefined') {
    try {
      localStorage.setItem(SEARCH_STORAGE_KEY, JSON.stringify(conditions));
    } catch (error) {
      console.error('Failed to save search conditions:', error);
    }
  }
};

export const loadSearchConditions = (): SearchFilters | null => {
  if (typeof window !== 'undefined') {
    try {
      const stored = localStorage.getItem(SEARCH_STORAGE_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      console.error('Failed to load search conditions:', error);
      return null;
    }
  }
  return null;
};

export const clearSearchConditions = (): void => {
  if (typeof window !== 'undefined') {
    try {
      localStorage.removeItem(SEARCH_STORAGE_KEY);
    } catch (error) {
      console.error('Failed to clear search conditions:', error);
    }
  }
};

